import React from "react"
import { EndpointConfig, RoutesConfig } from "../config"
import { useNavigate } from "react-router-dom"
import { getCookie, isAuth, signOut } from "../helper/auth"
import Button from "./atoms/button.atom"
import { axiosInstance } from "../lib/axios"

function Login() {
	const navigation = useNavigate()

	React.useEffect(() => {
		if (!isAuth() || isAuth().role !== "User") {
			navigation(RoutesConfig.UserLogin)
		}
	}, [])

	const logout = async () => {
		const token = getCookie("token")
		await axiosInstance.post(
			EndpointConfig.Logout,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`
				},
				withCredentials: true
			}
		)
		signOut()
		navigation(RoutesConfig.UserLogin)
	}

	const loginViaHub = () => {
		window.location.href =
			EndpointConfig.apiUrl + EndpointConfig.hubspotLogin 
	}
	return (
		<div className="flex flex-col">
			<h1 className="flex justify-between px-8 py-3 text-lg font-bold bg-white shadow">
				<img className="h-10" src="./logo.png" alt="Logo" />

				<div className="px-2 text-sm font-bold">
					<Button onClick={() => logout()}>Logout</Button>
				</div>
			</h1>

			<div className="my-8"></div>
			<div className="flex flex-row items-center justify-center">
				<div className="flex flex-col items-center justify-center h-full">
					<div className="p-4 bg-white rounded-lg shadow-lg w-96">
						<span className="text-xs text-gray-500 uppercase">Login</span>
						<h4 className="mb-4 text-2xl text-bold">Hubspot OAuth</h4>
						<Button
							//  className="px-4 py-3 text-lg bg-red-100 rounded-full"
							onClick={loginViaHub}
						>
							Login via Hubspot
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Login
